import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  IWHFlowContactDTO,
  IWHFlowMetadataTranslationModel,
  WHMetadataDataService,
} from '@workheld/workheld-shared-lib';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'w-h-contact-card',
  templateUrl: './w-h-contact-card.component.html',
  styleUrl: './w-h-contact-card.component.scss',
  imports: [TranslateModule, CommonModule, MatIconModule],
  standalone: true,
})
export class WHContactCardComponent implements OnInit {
  @Input() public contactDTO: IWHFlowContactDTO;
  @Output() public openModal: EventEmitter<any> = new EventEmitter();

  private subscriptions: Subscription[] = [];

  public CONTACT_SALUTATION: any;

  constructor(private metadataDataService: WHMetadataDataService) {}
  ngOnInit(): void {
    // WH ENUMS
    this.subscriptions.push(
      this.metadataDataService.metadataTranslation$.subscribe(
        (metadataTranslation: IWHFlowMetadataTranslationModel) => {
          this.CONTACT_SALUTATION = metadataTranslation.CONTACT_SALUTATION;
        },
      ),
    );
  }

  contactCrud(contact: IWHFlowContactDTO) {
    this.openModal.emit(contact);
  }
}
